import { ButtonBase } from "@mui/material";
import { useEffect, useState } from "react";

const LnSwitchBox = (props) => {
  const { title, tabs, value } = props;
  const [tabIdx, setTabIdx] = useState(0);
  const handleSwitch = (idx, tabId, name,) => {
    setTabIdx(idx);
    if (props.settingsHandle) {
       let titleName =  title.toLowerCase();
      if(titleName=='category'){
        titleName = 'type';
      }else if(titleName=='type'){
        titleName = 'category';
      }
      props.settingsHandle(idx, titleName, tabId);
    }
    if (props.settingsHandler) {
      props.confirmationModalHandler(true);
      localStorage.setItem("idx", idx);
      localStorage.setItem("title", title.toLowerCase());
      localStorage.setItem("tabId", tabId);
    }
  };
  return (
    <div className={`switch_tab mr-[20px] mb-[15px] inline-block`}>
      <label className="text-[13px] text-[#878B91] mb-[10px] inline-flex items-center">
        {title && title}
      </label>
      <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
        {(title == "Approval Time" || title == "Loan to Value") && (
          <ButtonBase key={0}>
            <span
              className={`switch ${
                (value === null || value === "") && "active"
              } ${props.disab && "pointer-events-none"}`}
              onClick={() => handleSwitch(-1, null, 0)}
            >
              All
            </span>
          </ButtonBase>
        )}
        {tabs.map((tab, idx) => {
          return (
            <ButtonBase
              key={idx}
              disabled={tab?.disabled || props.disab ? true : false}
            >
              <span
                className={`switch ${
                  value !== undefined
                    ? value === tab?.id && "active"
                    : tabIdx === idx && "active"
                } ${props.disab && "pointer-events-none"}`}
                onClick={() => handleSwitch(idx, tab.id, tab.name)}
              >
                {tab.name}
              </span>
            </ButtonBase>
          );
        })}
      </div>
    </div>
  );
};

export default LnSwitchBox;
